module.exports = __webpack_public_path__ + "static/contactjay-4d8eb6f57707f5309684e34ce644c128.jpg";